/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    callback
  );

export const getSingleBarangay = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BARANGAY,
    `api/v1/rpt/administrator/settings/barangays/${id}`,
    payload,
    callback
  );

export const createBarangay = (payload, callback) =>
  req.create(
    c.CREATE_BARANGAY,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBarangay = (id, payload, callback) =>
  req.update(
    c.UPDATE_BARANGAY,
    `api/v1/rpt/administrator/settings/barangays/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeBarangay = (id, payload, callback) =>
  req.remove(
    c.REMOVE_BARANGAY,
    `api/v1/rpt/administrator/settings/barangays/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICT_LIST,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );


